import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <Section className="relative overflow-hidden bg-ink-950" data-id="element-135" data-mp="3udfc7a8y1rnh">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-[30rem] w-[30rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent/12 blur-[150px]" data-id="element-136" data-mp="c6sldjejycdw" />
      <div className="relative text-center" data-id="element-137" data-mp="87jrmejiieic">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-138" data-mp="m46s2raobmt0">
          Reflexión final
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl" data-id="element-139" data-mp="h5c6xip8hm5q">
          Tu iPhone ya tiene todo lo que necesitas. Solo falta que aprendas a
          usarlo.
        </h2>

        <div className="mx-auto mt-7 max-w-2xl space-y-4 text-base leading-relaxed text-white/65 sm:text-lg" data-id="element-140" data-mp="qxrpoi8cuero">
          <p data-id="element-141" data-mp="14t3igk2y9v5y">
            Tienes en tu bolsillo uno de los dispositivos más potentes que
            existe, un aparato que costó mucho dinero y que puede organizar tu
            vida, proteger tus recuerdos, mejorar tu trabajo y ahorrarte tiempo.
          </p>
          <p className="text-white" data-id="element-142" data-mp="2h4j3b3iuc2su">
            Y hoy lo estás usando al 20% de su potencial.
          </p>
          <p data-id="element-143" data-mp="2m19i7niwssco">
            No porque seas descuidado, sino porque nadie te enseñó cómo hacerlo
            de forma simple, ordenada y completa. Diccionario Apple existe para
            cambiar eso: para que uses tu iPhone con confianza, con control y
            con la sensación de que por fin lo dominas de verdad.
          </p>
          <p className="text-xl font-extrabold text-white sm:text-2xl" data-id="element-144" data-mp="34tc0f3b78gp1">
            El momento de empezar es ahora. No mañana. Ahora.
          </p>
        </div>

        <div className="mt-10" data-id="element-145" data-mp="39rvp3bh6g6l3">
          <CTAButton className="items-center" note="Acceso inmediato después de tu compra. Sin esperas. Sin complicaciones." data-id="element-146" data-mp="39u9jrj7y3gs4" />
        </div>
      </div>
    </Section>;
}